import {Mapper} from '@s-ui/domain'

export class SeoAdsListSemanticLifestyleMetaConfigMapper extends Mapper {
  #config
  #seoConfig

  constructor({config}) {
    super()
    this.#config = config
    this.#seoConfig = this.#config.get('seo')
  }

  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * */
  static create({config}) {
    return new SeoAdsListSemanticLifestyleMetaConfigMapper({config})
  }

  #getAdsListSemanticConfigKey = ({path}) => {
    if (!path) return 'default'

    if (path.includes('/coches-para-familias/')) return 'familias'
    if (path.includes('/coches-para-ciudad/')) return 'ciudad'
    if (path.includes('/coches-pequenos/')) return 'pequenos'
    if (path.includes('/coches-bajas-emisiones/')) return 'bajasEmisiones'
    if (path.includes('/primer-coche-conductor-novel/')) return 'primerCoche'

    return 'default'
  }

  map = ({adsListSemanticConfig, params: {path}}) => {
    const adsListSemanticConfigKey = this.#getAdsListSemanticConfigKey({
      path
    })

    return adsListSemanticConfig[adsListSemanticConfigKey]
  }
}
